import styled from 'styled-components';

// e-mail: marcos.pedra@conforce.com.br
// senha: conforce@123

export const DetailsContainer = styled.div`
  width: 100%;
`;

export const Details = styled.div`
  position: relative;
  width: 100%;
  margin-top: 7px;
  overflow: none;
  z-index: 1;
`;

export const Title = styled.label`
  display: inline-block;
  font-size: 1.4rem;
  color: ${({ error }) => (error ? 'var(--danger)' : '#888')};
`;

export const Input = styled.input`
  &[type='checkbox'] {
    margin-left: 10px;
  }
  &[type='text'] {
    outline: none;
    color: #333;
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
    padding: 10px;
    position: sticky;
    top: 0;
  }
`;

export const Label = styled.label`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;
  color: var(--color);
`;

export const Summary = styled.div`
  cursor: pointer;
  padding: 1rem;

  color: var(--color);
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
  border: 2px solid ${({ error }) => (error ? 'var(--danger)' : '#f3f3f3')};
`;

export const Ul = styled.ul`
  width: 100%;
  border-left: 1px solid ${({ error }) => (error ? 'var(--danger)' : '#f3f3f3')};
  border-right: 1px solid
    ${({ error }) => (error ? 'var(--danger)' : '#f3f3f3')};
  border-bottom: 1px solid
    ${({ error }) => (error ? 'var(--danger)' : '#f3f3f3')};
  background: var(--background-color);
  top: calc(100% + 0.2rem);
  left: 0;
  overflow-y: auto;
  max-height: 350px;
`;

export const Li = styled.li`
  height: 40px;
  display: grid;
  grid-template-columns: auto 1fr;
  border-bottom: 2px solid #f3f3f3;
  align-items: center;
  gap: 10px;

  &:last-child {
    border-bottom: none;
  }
`;
